export const useProgressCalculation = (cursoData) => {
  const calculateMaterialsPercentage = (materials) => {
    if (!materials || !Array.isArray(materials)) {
      return 0;
    }
    
    const totalMaterials = materials.length;
    const completedMaterials = materials.filter((m) => m.completado).length;
    return totalMaterials > 0
      ? Math.round((completedMaterials / totalMaterials) * 100)
      : 0;
  };

  const calculateTotalPercentage = (materials, surveyLocalStorage = null) => {
    if (!materials || !Array.isArray(materials)) {
      return 0;
    }
    
    const completedMaterials = materials.filter((m) => m.completado).length;
    const totalMaterials = materials.length;
    
    const hasSurvey = Boolean(cursoData?.encuesta?.idEncuesta);
    const surveyCompleted = surveyLocalStorage?.completada || false;
    
    if (!hasSurvey) {
      return totalMaterials > 0
        ? Math.round((completedMaterials / totalMaterials) * 100)
        : 0;
    } else {
      const totalItems = totalMaterials + 1;
      const completedItems = completedMaterials + (surveyCompleted ? 1 : 0);
      
      return totalItems > 0
        ? Math.round((completedItems / totalItems) * 100)
        : 0;
    }
  };

  return {
    calculateMaterialsPercentage,
    calculateTotalPercentage
  };
};